<nb-layout>
  <nb-layout-header subheader clipped>
    <ngx-header></ngx-header>
  </nb-layout-header>

  <nb-sidebar class="menu-sidebar" tag="menu-sidebar" responsive start>
    <nb-sidebar-header>
      <div class="sidebar-toggle-container">
        <div (click)="toggleSidebar()" href="#" class="sidebar-toggle">
          <span class="toggle-icon" *ngIf="sideBarCollapse">
            <i class="fas fa-angle-right"></i>
          </span>
          <span class="toggle-icon" *ngIf="!sideBarCollapse">
            <i class="fas fa-angle-left"></i>
          </span>
        </div>
      </div>

      <div *ngIf="subDomain==='admin'" [ngClass]="{'logo-compacted': sideBarCollapse, 'logo': !sideBarCollapse}"
        (click)="navigateHome()"></div>
      <div *ngIf="subDomain!=='admin'" class="tenant-logo" (click)="navigateHome()">
        <img *ngIf="showTenantLogo" [src]="getImage()" [alt]="tenantSetting?.tenantBusinessName" [ngClass]="{'compacted': sideBarCollapse, 'normal': !sideBarCollapse}">
      </div>
    </nb-sidebar-header>
    <!-- <div class="header-container">

          </div> -->
    <ng-content select="nb-menu"></ng-content>
  </nb-sidebar>

  <nb-layout-column>
    <ng-content select="router-outlet"></ng-content>
  </nb-layout-column>

</nb-layout>